import styled from 'styled-components';
import { Stack, Box, ShortText } from 'src/viewLayer/components/DesignSystem';

export const ImageContainer = styled(Box)<{ positionFromBottom: string; positionFromRight: string }>`
  bottom: ${({ positionFromBottom }: { positionFromBottom: string }): string => positionFromBottom};
  position: absolute;
  right: ${({ positionFromRight }: { positionFromRight: string }): string => positionFromRight};
  width: fit-content;
  z-index: 1;
`;

export const CourseInfoTitle = styled(ShortText)`
  z-index: 2;
`;

export const CourseInfoItem = styled(Stack)
  <{
    cardId: string;
    cardImage: string;
    cardColor: string;
    cardHeight: string;
    cardWidth: string;
    cardPositionFromBottom: string;
    cardPositionFromRight: string
  }>`
  background-color: ${({ cardColor }: { cardColor: string }): string => cardColor};
  border-radius: 0.625rem;
  height: ${({ cardHeight }: { cardHeight: string }): string => cardHeight};
  padding: 1rem;
  position: absolute;
  width: ${({ cardWidth }: { cardWidth: string }): string => cardWidth};
  bottom: ${({ cardPositionFromBottom }: { cardPositionFromBottom: string }): string => cardPositionFromBottom};
  right: ${({ cardPositionFromRight }: { cardPositionFromRight: string }): string => cardPositionFromRight};
`;

export const InfoItemsWrapper = styled(Box)`
  width: 100%;
  min-height: 188px;
  position: relative;
`;
